import ApiService from '@/services/api.service'
import type { CreateTrackingEventPayload } from '@/types'
import { UserTypes } from '@/types'
import type { AxiosPromise } from 'axios'

const MetricService = {
  trackClientHome: (org_id: number): AxiosPromise => {
    const requestBody: CreateTrackingEventPayload = {
      name: 'Client Home',
      user: UserTypes.CLIENT,
      organization_id: org_id
    }
    return ApiService.post(`/t/event`, requestBody, {})
  },

  trackClientPdfDocument: (org_id: number): AxiosPromise => {
    const requestBody: CreateTrackingEventPayload = {
      name: 'Client PDFDocument',
      user: UserTypes.CLIENT,
      organization_id: org_id
    }
    return ApiService.post(`/t/event`, requestBody, {})
  },

  trackClientQuestionnaire: (org_id: number): AxiosPromise => {
    const requestBody: CreateTrackingEventPayload = {
      name: 'Client Questionnaire Edit',
      user: UserTypes.CLIENT,
      organization_id: org_id
    }
    return ApiService.post(`/t/event`, requestBody, {})
  }
}

export default MetricService
